// Shared utilities for CRM dashboards
import React, { useState, useEffect } from 'react';

export const ago = d => {
  const s = (Date.now() - new Date(d)) / 1000;
  if (s < 60) return 'ahora';
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};

export const fmtTime = s => {
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
};

export const dateStr = daysAhead => {
  const d = new Date();
  d.setDate(d.getDate() + daysAhead);
  return d.toISOString().split('T')[0];
};

export const fmtMXN = n => '$' + Number(n).toLocaleString('es-MX');

// ── Paginación compartida ────────────────────────────────────────────────────
// Hook: corta una lista en páginas para que no crezca indefinidamente.
// Devuelve { paged, page, setPage, pageCount, total, pageSize } para usar con <Pagination/>.
export function usePaged(list, pageSize = 12) {
  const arr = Array.isArray(list) ? list : [];
  const [page, setPage] = useState(1);
  const total = arr.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  // Si la página actual queda fuera de rango (p.ej. tras filtrar) ajusta a la última válida.
  useEffect(() => { if (page > pageCount) setPage(pageCount); }, [pageCount, page]);
  const safePage = Math.min(page, pageCount);
  const start = (safePage - 1) * pageSize;
  const paged = arr.slice(start, start + pageSize);
  return { paged, page: safePage, setPage, pageCount, total, pageSize, start };
}

// Controles de paginación (anterior · números · siguiente). No renderiza nada con 1 sola página.
export function Pagination({ page, setPage, pageCount, total, pageSize, primary = '#4f6ef7', label = 'registros' }) {
  if (!pageCount || pageCount <= 1) return null;
  const from = (page - 1) * pageSize + 1;
  const to   = Math.min(page * pageSize, total);
  let ini = Math.max(1, page - 2);
  let fin = Math.min(pageCount, ini + 4);
  ini = Math.max(1, fin - 4);
  const nums = [];
  for (let i = ini; i <= fin; i++) nums.push(i);
  const go = n => setPage(Math.min(pageCount, Math.max(1, n)));
  const btn = {
    minWidth: 32, height: 32, padding: '0 9px', borderRadius: 8,
    border: '1px solid #e2e8f0', background: '#fff', color: '#475569',
    fontSize: 12, fontWeight: 700, cursor: 'pointer', textAlign: 'center', lineHeight: '30px',
  };
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10, padding:'14px 4px 4px' }}>
      <span style={{ fontSize:12, color:'#94a3b8' }}>Mostrando {from}–{to} de {total} {label}</span>
      <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
        <button onClick={()=>go(page-1)} disabled={page<=1}
          style={{ ...btn, opacity:page<=1?0.4:1, cursor:page<=1?'default':'pointer' }}>‹</button>
        {ini>1 && <span style={{ fontSize:12, color:'#cbd5e1' }}>…</span>}
        {nums.map(n=>(
          <button key={n} onClick={()=>go(n)}
            style={{ ...btn, ...(n===page ? { background:primary, color:'#fff', borderColor:primary } : {}) }}>{n}</button>
        ))}
        {fin<pageCount && <span style={{ fontSize:12, color:'#cbd5e1' }}>…</span>}
        <button onClick={()=>go(page+1)} disabled={page>=pageCount}
          style={{ ...btn, opacity:page>=pageCount?0.4:1, cursor:page>=pageCount?'default':'pointer' }}>›</button>
      </div>
    </div>
  );
}

